import utils from "../../../../utils/utilsGraficos"

function informaCampo(selectCampo) {
    var propriedades = [
        "N.° de Turmas",
        "N.º de Alunos Turmas",
        "Carga Horária",
        "Mat. Residuais",
        "Mat. Novas",
        "Total Mat.",
        "Hora/aluno",
        "Carga H. Turma/Ano",
        "Necessidade de docente (8h)",
        "Necessidade de docente (7,2h)"
    ]
    return propriedades[selectCampo]
}

function calculaTipoPorMes({ metas, selectCampo, modalidade, unidade, event }) {

    let modalidades = [
        "Iniciação Profissional à Distância",
        "Iniciação Profissional Presencial",
        "Qualificação Profissional Presencial",
        "Qualificação Profissional a Distância",
        "Aperfeiçoamento/Espec.Profis.a Distância",
        "Aperfeiçoamento/Espec.Profiss.Presencial",
        "Qualificação Profissional - Itinerário V Ensino Médio",
        "Técnico de Nível Médio Presencial",
        "Técnico de Nível Médio a Distância",
        "Técnico N.Médio Presencial Itinerário V",
        "Aprendizagem Industrial Presencial",
        "Aprendizagem Industrial a Distância",
        "Aprendizagem Industrial Técnica Presenc.",
        "Graduação Tecnológica Presencial",
        'Pós-Graduação "lato sensu" - Especializa',
        "Cursos de Extensão Presencial",
        "Cursos de Extensão a Distância"
    ]

    let tipo = ["Pago", "Gratuidade Regimental", "Gratuidade Não-Regimental"];

    let filtros = {
        unidade: unidade
    }

    if (Boolean(event)) {
        let evento = event.target.value;

        if (event.target.id === "selectUnidade") {
            filtros.unidade = evento
            unidade = evento
        }
        if (event.target.id === "selectCampo") {
            selectCampo = evento;
        }
    }

    if (unidade === "Todas") delete filtros.unidade;

    let json = {}

    modalidades.forEach((modalidade, ind) => {
        filtros.modalidade = modalidade;
        let totalTipos = []

        let dados = tipo.map(tipo => {
            filtros.tipo = tipo;
            let meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
            let metasFiltradas = utils.filtrar(metas, filtros);
            let resultados = meses.map(mes => utils.total(metasFiltradas, mes)[selectCampo]);
            let total = resultados.reduce((acc, atual) => acc + atual, 0);
            totalTipos.push(total);
            return resultados
        });

        let total = totalTipos.reduce((acc, atual) => acc + atual, 0);

        json[modalidade] = {
            dados,
            totalTipos,
            total
        }

    });

    filtros = { unidade }
    if (unidade === "Todas") delete filtros.unidade;

    let dados = tipo.map(tipo => {
        filtros.tipo = tipo;
        let meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
        let metasFiltradas = utils.filtrar(metas, filtros);
        let resultados = meses.map(mes => utils.total(metasFiltradas, mes)[selectCampo]);
        return resultados
    });

    let totais = []
    dados.forEach(tipo => {
        let total = tipo.reduce((acc, atual) => acc + atual, 0);
        totais.push(total);
    });

    return {
        json,
        dados,
        totais,
        modalidade: modalidade,
        unidade: unidade,
        selectCampo: selectCampo,
        nomeCampo: informaCampo(selectCampo)
    };

}

export default { informaCampo, calculaTipoPorMes }
